<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> {{ userGroupEdit ? 'Edit' : userGroupView ? 'View' :
        'Add' }}
        User Group</div>
    <!-- <ngx-loading [show]="loading"></ngx-loading> -->

    <form [formGroup]="userGroupForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Index</mat-label>
                    <input matInput formControlName="index">
                    <ng-container *ngIf="formSubmitted && formValues['index'].errors">
                        <mat-error *ngIf="formValues['index'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Index is required
                        </mat-error>
                        <mat-error *ngIf="formValues['index'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>User Group</mat-label>
                    <input matInput formControlName="groupName">
                    <ng-container *ngIf="formSubmitted && formValues['groupName'].errors">
                        <mat-error *ngIf="formValues['groupName'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>User Group is required
                        </mat-error>
                        <mat-error *ngIf="formValues['groupName'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Feature Privilage</mat-label>
                    <mat-select [disableOptionCentering]="true" formControlName="privilege"
                        [(ngModel)]="userGroupForm.value['privilege']"
                        (ngModelChange)="userGroupForm.value['privilege']" multiple (closed)="triggerEvent($event)"
                        (focus)="clearDropDownSearch=false" panelClass="multiSelectPanel">
                        <app-search-dropdown (searchItem)="searchTerm=$event" class="d-flex border-bottom mb-4"
                            [clearSearch]="clearDropDownSearch">
                        </app-search-dropdown>
                        <mat-option #allSelected (click)="toggleAllSelection()" [value]="0">Select All</mat-option>
                        <mat-option *ngFor="let item of featurePrivilegeList  | commonSearch:searchTerm:'label':'name'"
                            [value]="item.name" selected title="{{item.label}}"
                            (click)="tosslePerOne(allSelected.viewValue)">
                            {{item.name}} - {{item.label}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="formSubmitted && formValues['privilege'].errors">
                        <mat-error *ngIf="formValues['privilege'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Feature Privilage is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
                    class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button *ngIf="!userGroupView" mat-raised-button color="primary" type="submit">
                {{ userGroupEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
</div>